module.exports = __webpack_public_path__ + "static/media/milosz.a9b12a12.jpg";